import { Card, CardContent } from "@/components/ui/card.jsx";
import { Button } from "@/components/ui/button.jsx";
import { Mail, LogOut } from "lucide-react";
import { useEffect } from "react";
import { logOut } from "@/api/detechtion-account-api.js";
import { useSessionTenant } from "@/contexts/SessionTenantContext.jsx";
import TenantSwitcher from "@/components/tenant-switcher.jsx";

const LAUNCHPAD_URL = import.meta.env.VITE_LAUNCHPAD_URL;

/**
 * Shown when OneView is disabled for the current session tenant.
 * @returns {JSX.Element}
 */
export default function OneViewDisabled() {
  const { availableTenants } = useSessionTenant();

  const showTenantSwitch = availableTenants.length > 1;

  useEffect(() => {
    const base = import.meta.env.BASE_URL || "/";
    if (base === "/" && window.location.pathname !== "/") {
      window.history.replaceState(null, "", "/");
    }
  }, []);

  const handleLogout = () => {
    logOut(() => {
      window.location.href = LAUNCHPAD_URL || "/";
    });
  };

  return (
    <div className='min-h-screen w-full flex items-center justify-center bg-background p-4'>
      <Card className='w-full max-w-lg rounded-lg border border-border bg-card shadow-sm'>
        <CardContent className='pt-8 pb-6 px-6 sm:px-8'>
          <h1 className='text-xl font-semibold text-foreground'>
            OneView is not available for this tenant
          </h1>
          <p className='mt-4 text-sm text-muted-foreground leading-relaxed'>
            Application access for OneView has been disabled for your
            organization. To restore access or discuss licensing, contact{" "}
            <a
              href='mailto:Sales@detechtion.com'
              className='text-brand-cyan font-medium underline-offset-2 hover:underline'>
              Sales@detechtion.com
            </a>{" "}
            or your Detechtion account manager.
          </p>

          <div className='mt-6 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950'>
            <Mail className='h-4 w-4 shrink-0 mt-0.5' />
            <span>
              Prefer email? Reach us at Sales@detechtion.com for the fastest
              routing.
            </span>
          </div>

          {showTenantSwitch ? (
            <div className='mt-8 rounded-lg border border-border bg-card p-4'>
              <p className='text-sm font-medium text-foreground mb-3'>
                Switch to another tenant
              </p>
              <div className='max-w-xs'>
                <TenantSwitcher />
              </div>
            </div>
          ) : null}

          <div className='mt-8'>
            <Button
              type='button'
              onClick={handleLogout}
              variant='ghost'
              size='sm'
              className='w-full justify-center font-light text-sm border border-destructive text-destructive hover:bg-destructive hover:!text-white hover:[&_svg]:!text-white transition-colors'>
              <LogOut className='h-4 w-4 mr-2' />
              Log Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
